import { useState, FormEvent } from 'react';

const ASSUNTOS = [
  'Consulta Dermatológica',
  'Procedimento Estético',
  'Pequeno Procedimento Cirúrgico',
  'Dúvida sobre Tratamento',
  'Outro',
];

export default function ContactForm() {
  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form) as unknown as URLSearchParams);

    setStatus('sending');
    try {
      const res = await fetch('https://readdy.ai/api/form/d6u2s8q9puk3bj9672jg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      if (res.ok) {
        setStatus('success');
        form.reset();
        setCharCount(0);
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  const inputClass =
    'w-full bg-[#FBF8F3] border border-[#E8DCC8] rounded-lg px-4 py-3 text-sm text-[#4A3F35] placeholder-[#B8A898] focus:outline-none focus:border-[#C4A57B] transition-colors';

  return (
    <div className="bg-white rounded-2xl border border-[#E8DCC8] p-8 sm:p-10">
      <div className="mb-8">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#FBF8F3] rounded-full mb-4">
          <div className="w-1.5 h-1.5 bg-[#C4A57B] rounded-full" />
          <span className="text-xs text-[#8B7355] font-medium">Formulário de Contato</span>
        </div>
        <h2 className="text-2xl sm:text-3xl font-light text-[#4A3F35] leading-tight">
          Envie uma <span className="italic text-[#C4A57B]">mensagem</span>
        </h2>
        <p className="text-sm text-[#8B7355] mt-2 leading-relaxed">
          Preencha o formulário e retornaremos em até 24 horas úteis.
        </p>
      </div>

      {status === 'success' ? (
        <div className="py-12 text-center">
          <div className="w-16 h-16 bg-[#FBF8F3] rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="ri-check-line text-[#C4A57B] text-3xl" />
          </div>
          <h3 className="text-xl font-medium text-[#4A3F35] mb-2">Mensagem enviada!</h3>
          <p className="text-sm text-[#8B7355]">Em breve entraremos em contato.</p>
          <button
            onClick={() => setStatus('idle')}
            className="mt-6 px-6 py-2.5 bg-[#C4A57B] text-white text-sm font-medium rounded-full hover:bg-[#B39568] transition-colors cursor-pointer"
          >
            Enviar nova mensagem
          </button>
        </div>
      ) : (
        <form
          onSubmit={handleSubmit}
          data-readdy-form
          id="contato-consultorio"
          className="space-y-5"
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <div>
              <label className="block text-xs font-medium text-[#8B7355] mb-1.5">Nome completo *</label>
              <input
                name="nome"
                type="text"
                required
                placeholder="Seu nome"
                className={inputClass}
              />
            </div>
            <div>
              <label className="block text-xs font-medium text-[#8B7355] mb-1.5">Telefone / WhatsApp *</label>
              <input
                name="telefone"
                type="tel"
                required
                placeholder="(48) 99999-0000"
                className={inputClass}
              />
            </div>
          </div>

          <div>
            <label className="block text-xs font-medium text-[#8B7355] mb-1.5">E-mail *</label>
            <input
              name="email"
              type="email"
              required
              placeholder="seuemail@exemplo.com"
              className={inputClass}
            />
          </div>

          <div>
            <label className="block text-xs font-medium text-[#8B7355] mb-1.5">Assunto</label>
            <select name="assunto" className={inputClass}>
              <option value="">Selecione um assunto...</option>
              {ASSUNTOS.map((a) => (
                <option key={a} value={a}>{a}</option>
              ))}
            </select>
          </div>

          <div>
            <div className="flex justify-between mb-1.5">
              <label className="block text-xs font-medium text-[#8B7355]">Mensagem *</label>
              <span className={`text-xs ${charCount > 480 ? 'text-red-400' : 'text-[#B8A898]'}`}>
                {charCount}/500
              </span>
            </div>
            <textarea
              name="mensagem"
              required
              rows={5}
              maxLength={500}
              placeholder="Descreva sua dúvida ou como posso ajudá-la..."
              onChange={(e) => {
                if (e.target.value.length > 500) {
                  e.target.value = e.target.value.slice(0, 500);
                }
                setCharCount(e.target.value.length);
              }}
              className={`${inputClass} resize-none`}
            />
          </div>

          {status === 'error' && (
            <p className="text-sm text-red-500 flex items-center gap-2">
              <i className="ri-error-warning-line" />
              Ocorreu um erro. Tente novamente ou entre em contato pelo WhatsApp.
            </p>
          )}

          <button
            type="submit"
            disabled={status === 'sending'}
            className="w-full py-4 bg-[#C4A57B] text-white text-sm font-medium rounded-full hover:bg-[#B39568] disabled:opacity-60 transition-colors cursor-pointer flex items-center justify-center gap-2 whitespace-nowrap"
          >
            {status === 'sending' ? (
              <>
                <i className="ri-loader-4-line animate-spin" />
                Enviando...
              </>
            ) : (
              <>
                <i className="ri-send-plane-line" />
                Enviar Mensagem
              </>
            )}
          </button>
        </form>
      )}
    </div>
  );
}
